import { render, staticRenderFns } from "./MoreContactInfo.vue?vue&type=template&id=c5448584&scoped=true"
import script from "./MoreContactInfo.vue?vue&type=script&lang=js"
export * from "./MoreContactInfo.vue?vue&type=script&lang=js"
import style0 from "./MoreContactInfo.vue?vue&type=style&index=0&id=c5448584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5448584",
  null
  
)

export default component.exports